function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M6.23906 3.5652C7.18522 3.5652 7.95224 2.7671 7.95224 1.7826C7.95224 0.798098 7.18522 0 6.23906 0C5.29289 0 4.52588 0.798098 4.52588 1.7826C4.52588 2.7671 5.29289 3.5652 6.23906 3.5652Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M12.1358 16.5254C12.2936 16.5254 12.4533 16.4804 12.5965 16.3864C13.0006 16.121 13.1213 15.5654 12.8662 15.145L10.2842 10.8886C10.1259 10.6274 9.84963 10.469 9.55285 10.469H6.8915V7.02719L7.96423 8.56419C8.0909 8.74559 8.2931 8.85279 8.50857 8.85279H11.0975C11.469 8.85279 11.7702 8.53939 11.7702 8.15279C11.7702 7.76619 11.469 7.45279 11.0975 7.45279H8.85128L6.68929 4.35499C6.57992 4.19839 6.41981 4.10279 6.24951 4.07479C6.09517 3.99519 5.92198 3.94919 5.73823 3.94919C5.10143 3.94919 4.58496 4.48659 4.58496 5.14919V10.9832C4.58496 11.2018 4.64205 11.406 4.74008 11.5824C4.83272 11.9758 5.17121 12.2686 5.57773 12.2686H9.07598L11.4037 16.1054C11.5682 16.3768 11.8488 16.5254 12.1358 16.5254Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M9.83583 14.7274C9.65342 14.6142 9.41739 14.6762 9.30879 14.8658C8.48305 16.3056 6.97073 17.2 5.36154 17.2C2.82916 17.2 0.768845 15.0562 0.768845 12.4212C0.768845 10.4552 1.95383 8.6616 3.71717 7.9576C3.91534 7.8784 4.01433 7.6472 3.93841 7.441C3.86248 7.2348 3.6399 7.1314 3.44193 7.2108C1.38334 8.0324 0 10.1264 0 12.4212C0 15.4974 2.40514 18 5.36154 18C7.24002 18 9.00548 16.9562 9.96884 15.2758C10.0778 15.0862 10.018 14.8406 9.83583 14.7274Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "FillColor",
  cx: 5.5,
  cy: 12.5,
  r: 3.5,
  fill: "black"
});

var SvgWheelchairHeavy = function SvgWheelchairHeavy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheelchairHeavy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheelchair_heavy.93fefab7.svg";
export { ForwardRef as ReactComponent };